import { useCallback, useMemo } from 'react'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import Places from 'constants/places'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from '../constants/luxPlusMonthTakeoverConstants'

// Same "hidden offer" filter shape as the LuxPlus+ landing page's Hidden Offers tab
// (LuxPlusFilteredOfferCarousel's getFiltersForCategory('hidden-offers', ...)), but rendered
// through the standard, un-blurred OfferCardCarouselSection tile rather than the locked/blurred
// LuxPlusHiddenOfferCarouselCard treatment — these are shown fully visible to everyone during
// the campaign, members and non-members alike. Scoped to this campaign's tag, on top of the
// member-exclusive filter.
function LuxPlusMonthTakeoverHiddenOfferCarousel() {
  const renderItalic = useCallback((chunks: ReactNode) => <i>{chunks}</i>, [])

  const filters = useMemo<App.OfferListFilters>(() => ({
    offerTypes: ['hotel', 'tactical_ao_hotel'],
    campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
    luxPlusFeatures: ['Member exclusive'],
    destinations: [Places.Anywhere.id],
    scheduleVisibilities: ['luxPlusExclusiveVisible'],
    limit: 20,
  }), [])

  const allLink = useMemo(() => `/search?${getSearchQueryFromFilter(filters).toString()}`, [filters])

  return (
    <OfferCardCarouselSection
      id="lux-plus-month-hotels"
      title={<FormattedMessage
        id="8TzlAaZOBt88pV8eDLdV"
        defaultMessage="<i>Exclusive</i> LuxPlus+ offers"
        description="Section title for the LuxPlus+ Month campaign landing page carousel showing member-exclusive hidden offers, unblurred, to all visitors, with 'Exclusive' shown in italics"
        values={{ i: renderItalic }}
      />}
      filters={filters}
      allLink={allLink}
      hideWhenEmpty
      tileStyle="card-default"
      tileSize="medium"
    />
  )
}

export default LuxPlusMonthTakeoverHiddenOfferCarousel
